import getI18nProps from '@/utils/i18/getI18nProps';
import { Box, Stack, Typography } from '@mui/material';
import { Trans, useTranslation } from 'next-i18next';
import React from 'react';

import useTheme from '@/theme/useTheme';
import WrappedButton from '@/components/ui/WrappedButton';

import banner1 from './assets/banner-1.png';
import Image from 'next/image';
import { useRouter } from 'next/router';

const BenefitsRakeback: React.FC = () => {
  const [t] = useTranslation(['benefits']);
  const { push } = useRouter();

  return (
    <Box>
      <Box
        sx={{
          float: 'right',
          display: ['none', 'none', 'inline-block'],
          ['img']: {
            maxWidth: '504px',
            height: 'auto',
          },
        }}
      >
        <Image src={banner1} alt="banner" />
      </Box>
      <Typography
        variant="h1"
        fontSize={'32px !important'}
        fontWeight={700}
        lineHeight={'100%'}
      >
        {t('benefits::GET MONEY BACK ON EVERY BET WITH RAKEBACK')}
      </Typography>
      <Typography color={'text.secondary'} mt={2}>
        <Trans
          i18nKey="Every time you place a bet at MoonClub, you get money back. This is done by taking a 6% Rakeback from the house edge of each bet. The money is credited to your account automatically every day.<br/><br/>Let’s break it down in simple terms. If you have a game with a 96.4% RTP, the Rakeback rewards increase it to a 97% RTP, making MoonClub the best casino to enjoy the best odds."
          ns="benefits"
        />
      </Typography>
      <Box
        sx={{
          float: 'right',
          display: ['', '', 'none'],
          ['img']: {
            maxWidth: '100%',
            height: 'auto',
          },
        }}
      >
        <Image src={banner1} alt="banner" />
      </Box>

      <Typography variant="h4" mt={8}>
        {t('benefits::What is Rakeback?')}
      </Typography>
      <Typography mt={2} color={'text.secondary'}>
        {t(
          'benefits::Rakeback is a reward that is credited to players based on the house edge. If a game has a 4% house edge, you will get back 6% of that 4% house edge as free money. This ultimately reduces the house edge, making MoonClub a more favourable casino.',
        )}
      </Typography>
      <Typography variant="h4" mt={8}>
        {t('benefits::How is Rakeback Credited?')}
      </Typography>
      <Typography mt={2} mb={2} color={'text.secondary'}>
        <Trans
          i18nKey={
            'First, 50% of your earned Rakeback will be ready to claim, and the other 50% will be split over the next five days. Any available daily claim will be added to your daily casino Rakeback allowance.<br/><br/>You can view your earned Rakeback under the Rewards drop-down.<br/><br/>The Rakeback is calculated every day at 00:00 UTC.'
          }
          ns="benefits"
        />
      </Typography>
      <WrappedButton
        variant={'contained'}
        sx={{
          textTransform: 'uppercase',
          alignSelf: 'flex-start',
          px: 8,
        }}
        onClick={() => {
          push('/casino');
        }}
      >
        {t('benefits::Play Now')}
      </WrappedButton>
      <Typography variant="h4" mt={4}>
        {t('benefits::Terms and Conditions')}
      </Typography>
      <Typography mt={2} color={'text.secondary'}>
        <ol
          style={{
            lineHeight: '1.8',
            paddingInlineStart: '1em',
            marginBlockStart: '0',
          }}
        >
          <Trans
            i18nKey={
              '<li>The casino Rakeback promotion is only available to players who have wagered $100 or more.</li><li>The Rakeback is calculated every at 00:00 UTC.</li><li>The Rakeback is credited as 50% on the first day, and then the remaining 50% is credited over the following five days.</li><li>The minimum Rakeback balance needed to split across five days is $0.003.</li><li>The Rakeback must be claimed within a week. The next calculation of the weekly Rakeback will reset the previous week’s earned Rakeback.</li><li>MoonClub reserves the right to update/change the promotion without notice.</li><li>MoonClub’s General Terms and Conditions apply.</li>'
            }
            ns="benefits"
            components={{
              li: <li></li>,
            }}
          ></Trans>
        </ol>
      </Typography>
    </Box>
  );
};

// export const runtime = 'experimental-edge';

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await getI18nProps({ locale, additionalNamespaces: ['benefits'] })),
    },
  };
}

export default BenefitsRakeback;
